export const GET_EVENT_PAYROLLS_REQUEST = "GET_EVENT_PAYROLLS_REQUEST";
export const GET_EVENT_PAYROLLS_RESPONSE = "GET_EVENT_PAYROLLS_RESPONSE";
export const GET_EVENT_PAYROLL_STATS_REQUEST =
  "GET_EVENT_PAYROLL_STATS_REQUEST";
export const GET_EVENT_PAYROLL_STATS_RESPONSE =
  "GET_EVENT_PAYROLL_STATS_RESPONSE";
